<template>
  <div class="mx-5">
    <v-breadcrumbs class="m-2 p-0" :items="breadcrumbsItems">
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    </v-breadcrumbs>

    <v-row>
      <v-col cols="12">
        <v-card class="mb-5">
          <v-card-title class="list-title">
            <span>Servis Logları</span>
          </v-card-title>

          <v-card-text>
            <v-row class="mb-4">
              <v-col cols="12" md="4">
                <v-menu
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="selectedDate"
                      label="Tarih"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      outlined
                      dense
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="selectedDate"
                    @input="dateMenu = false; fetchLogs()"
                    locale="tr"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="searchTerm"
                  label="Arama"
                  prepend-inner-icon="mdi-magnify"
                  outlined
                  dense
                  clearable
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-btn color="primary" @click="fetchLogs" block>
                  <v-icon left>mdi-refresh</v-icon>
                  Yenile
                </v-btn>
              </v-col>
            </v-row>

            <v-data-table
              :headers="headers"
              :items="filteredLogs"
              :loading="loading"
              :items-per-page="25"
              class="elevation-1"
              :footer-props="{
                itemsPerPageText: 'Sayfa başına kayıt:',
                itemsPerPageAllText: 'Tümü',
                nextText: 'Sonraki',
                prevText: 'Önceki'
              }"
            >
              <template v-slot:item.creationTime="{ item }">
                <span>{{ formatDate(item.creationTime) }}</span>
              </template>

              <template v-slot:item.methodName="{ item }">
                <v-chip
                  :color="getMethodColor(item.methodName)"
                  dark
                  small
                >
                  {{ item.methodName }}
                </v-chip>
              </template>

              <template v-slot:item.orderNo="{ item }">
                <span class="font-weight-bold">{{ item.orderNo }}</span>
              </template>

              <template v-slot:item.orderId="{ item }">
                <div class="text-truncate" style="max-width: 200px;">
                  {{ item.orderId }}
                </div>
              </template>

              <template v-slot:item.status="{ item }">
                <v-chip
                  :color="getStatusColor(item)"
                  dark
                  small
                >
                  {{ getRequestStatus(item) }}
                </v-chip>
              </template>

              <template v-slot:item.actions="{ item }">
                <v-btn
                  icon
                  small
                  @click="showLogDetails(item)"
                  color="primary"
                >
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Log Detail Modal -->
    <v-dialog v-model="detailDialog" max-width="1000px">
      <v-card>
        <v-card-title>
          <span class="headline">Request Log Detayı</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="detailDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text v-if="selectedLog">
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                label="Zaman"
                :value="formatDate(selectedLog.creationTime)"
                readonly
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="Method"
                :value="selectedLog.methodName"
                readonly
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="Order No"
                :value="selectedLog.orderNo"
                readonly
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="Durum"
                :value="getRequestStatus(selectedLog)"
                readonly
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                label="Order ID"
                :value="selectedLog.orderId"
                readonly
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-textarea
                label="Request"
                :value="formatJson(selectedLog.request)"
                readonly
                outlined
                auto-grow
                rows="10"
              ></v-textarea>
            </v-col>
            <v-col cols="12">
              <v-textarea
                label="Response"
                :value="formatJson(selectedLog.response)"
                readonly
                outlined
                auto-grow
                rows="10"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ajax from '@/lib/ajax';

export default {
  name: 'ServiceLogs',
  data() {
    return {
      breadcrumbsItems: [
        { text: 'Ana Sayfa', disabled: false, href: '#/' },
        { text: 'Servis Logları', disabled: true }
      ],
      searchTerm: '',
      selectedDate: new Date().toISOString().substring(0, 10),
      dateMenu: false,
      loading: false,
      detailDialog: false,
      selectedLog: null,
      headers: [
        { text: 'Order No', value: 'orderNo', width: '120px' },
        { text: 'Method', value: 'methodName', width: '150px' },
        { text: 'Tarih', value: 'creationTime', width: '180px' },
        { text: 'Durum', value: 'status', width: '120px' },
        { text: 'İşlemler', value: 'actions', sortable: false, width: '100px' }
      ],
      logs: [],
      totalCount: 0
    }
  },
  computed: {
    filteredLogs() {
      let filtered = this.logs;

      if (this.searchTerm) {
        filtered = filtered.filter(log => 
          log.orderNo.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
          log.orderId.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
          log.methodName.toLowerCase().includes(this.searchTerm.toLowerCase())
        );
      }


      return filtered.sort((a, b) => new Date(b.creationTime) - new Date(a.creationTime));
    }
  },
  async mounted() {
    await this.fetchLogs();
  },
  methods: {
    formatDate(date) {
      return new Date(date).toLocaleString('tr-TR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
    },
    getMethodColor(methodName) {
      switch (methodName) {
        case 'EgesenBook': return 'green';
        case 'TuiBook': return 'blue';
        case 'EgesenSearch': return 'teal';
        case 'TuiSearch': return 'indigo';
        case 'WegoSearch': return 'purple';
        case 'WegoBook': return 'deep-purple';
        default: return 'grey';
      }
    },
    getRequestStatus(log) {
      try {
        const response = JSON.parse(log.response);
        
        // Check for error in response
        if (response.error || (response.Tickets_BRON && response.Tickets_BRON.error)) {
          return 'HATA';
        }
        
        // Check for successful booking
        if (response.result && response.result.books) {
          return 'BAŞARILI';
        }
        
        // Check for successful response
        if (response.audit && !response.error) {
          return 'BAŞARILI';
        }
        
        return 'BILINMIYOR';
      } catch (e) {
        return 'BILINMIYOR';
      }
    },
    getStatusColor(log) {
      const status = this.getRequestStatus(log);
      switch (status) {
        case 'BAŞARILI': return 'green';
        case 'HATA': return 'red';
        default: return 'grey';
      }
    },
    formatJson(jsonString) {
      try {
        return JSON.stringify(JSON.parse(jsonString), null, 2);
      } catch (e) {
        return jsonString;
      }
    },
    showLogDetails(log) {
      this.selectedLog = log;
      this.detailDialog = true;
    },
    async fetchLogs() {
      this.loading = true;
      try {
        const response = await ajax.get(`/api/services/app/Admin/GetRequestLogs?Date=${this.selectedDate}`);
        const data = response.data;
        
        if (data.success) {
          this.logs = data.result.items;
          this.totalCount = data.result.totalCount;
        } else {
          this.$toast.error('Loglar yüklenirken hata oluştu');
        }
      } catch (error) {
        console.error('Error fetching logs:', error);
        this.$toast.error('Loglar yüklenirken hata oluştu');
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped>
.list-title {
  background-color: #f5f5f5;
  border-bottom: 1px solid #e0e0e0;
}
</style>